/*
 * action types
 */

export const RESET_FIELDS = 'RESET_FIELDS'
export const INSERT_FIELD = 'INSERT_FIELD'
export const SET_ACTIVE_SECTION = 'SET_ACTIVE_SECTION'
export const SET_VISIBILITY_FILTER = 'SET_VISIBILITY_FILTER'
export const INSERT_SECTION = 'INSERT_SECTION'
export const UPDATE_SECTION = 'UPDATE_SECTION'

/*
 * other constants
 */

// export const VisibilityFilters = {
//     SHOW_ALL: 'SHOW_ALL',
//     SHOW_COMPLETED: 'SHOW_COMPLETED',
//     SHOW_ACTIVE: 'SHOW_ACTIVE'
// }

/*
 * action creators
 */

export function resetFields(fields) {
    return { type: RESET_FIELDS, fields }
}
export function insertField(field) {
    return { type: INSERT_FIELD, field }
}
export function insertSection(field) {
    return { type: INSERT_SECTION, field }
}

export function updateSection(field) {
    return { type: UPDATE_SECTION, field }
}
// export function toggleTodo(index) {
//     return { type: TOGGLE_TODO, index }
// }
//
// export function setVisibilityFilter(filter) {
//     return { type: SET_VISIBILITY_FILTER, filter }
// }
